import script from "./WRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./WRadio.vue?vue&type=script&setup=true&lang=js"

import "./WRadio.vue?vue&type=style&index=0&id=600eceb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600eceb8"]])

export default __exports__